import { Step } from './step';

export class Steps {
    static getInitalSteps(
        i18nPipe: any,
        showSignaturePropoStep: boolean,
        isTopSansSelectionMedicale?: boolean
    ): Step[] {
        // Parcours sans selection medicale
        if (isTopSansSelectionMedicale) {
            return [
                {
                    isCurrent: false,
                    isCompleted: false,
                    id: 'info_doc_download',
                    title: i18nPipe.transform(
                        'adhesion.stepper.info-doc-download'
                    ),
                    isWithMandat: false,
                },
                {
                    isCurrent: false,
                    isCompleted: false,
                    id: 'signature_dad',
                    title: i18nPipe.transform('adhesion.stepper.signature.SSM'),
                    isWithMandat: false,
                },
                {
                    isCurrent: false,
                    isCompleted: false,
                    id: 'decision_assureur',
                    title: i18nPipe.transform(
                        'adhesion.stepper.finalisation.SSM'
                    ),
                    isWithMandat: false,
                },
            ];
        }
        // Parcous avec selection medicale
        const steps = [
            {
                isCurrent: false,
                isCompleted: false,
                id: 'qs',
                title: i18nPipe.transform('adhesion.stepper.introduction'),
                isWithMandat: false,
            },
            {
                isCurrent: false,
                isCompleted: false,
                id: 'signature_dad',
                title: i18nPipe.transform('adhesion.stepper.signature'),
                isWithMandat: false,
            },
            {
                isCurrent: false,
                isCompleted: false,
                id: 'etude_dossier',
                title: i18nPipe.transform(
                    'adhesion.stepper.document-selection'
                ),
                isWithMandat: false,
            },
            {
                isCurrent: false,
                isCompleted: false,
                id: 'decision_assureur',
                title: i18nPipe.transform('adhesion.stepper.finalisation'),
                isWithMandat: false,
            },
        ];

        if (showSignaturePropoStep) {
            steps.push({
                isCurrent: false,
                isCompleted: false,
                id: 'signature_propo',
                title: i18nPipe.transform(
                    'adhesion.stepper.insurance-proposition'
                ),
                isWithMandat: false,
            });
        }
        return steps;
    }
}
